<div *ngFor="let file of uploadedFiles; let i = index" class="file-show mb-2 uploaded-file-container col-12">
  <i class="fa fa-check-circle margin-vertical-middle"></i>
  <span>{{ file?.name }}</span>
  <i
    (click)="removeFile(i)"
    class="fa fa-trash margin-vertical-middle delete-icon"
    style="float: right"
    aria-hidden="true"
  >
  </i>
</div>

<div class="upload-filecustm text-center" *ngIf="uploadedFiles.length === 0 || showFileUploadBox">
  <div>
    <span>Drag your file here to upload </span>
    <div class="linetxt">
      <div class="title title--center-line">Or</div>
    </div>
    <button class="browse-button" (click)="fileInput.click()">BROWSE</button>
    <input
      type="file"
      id="files"
      name="files"
      [multiple]="enableMultiSelect"
      (change)="handleFileInput(enableMultiSelect ? $event.target.files : $event.target.files[0])"
      [accept]="inputAccept"
      style="display: none"
      #fileInput
    />
  </div>
</div>
<div class="d-flex justify-content-between">
  <div
    class="clear-button mt-1 justify-content-start acceptedFormatDescription"
    *ngIf="acceptedFormatMsg"
    [innerHTML]="acceptedFormatMsg"
  ></div>
  <div class="mt-3 justify-content-end d-flex" *ngIf="isMultiple">
    <button
      type="button"
      class="add-more-button"
      [disabled]="showFileUploadBox"
      [class.disabled]="showFileUploadBox"
      *ngIf="uploadedFiles.length > 0"
      (click)="addMoreFiles()"
    >
      Add More
    </button>
    <button type="button" class="clear-button width-90" (click)="clearSelectedFiles()">Clear All</button>
  </div>
</div>
